import { CGMProducts } from 'common-src/models/PatientCgmOrder';

export const DeviceOrderOptions = Object.freeze({
  DexcomG7_10Day: {
    value: 'DexcomG7_10Day',
    label: 'Dexcom G7 10-day',
    cgmModel: 'Dexcom G7',
    product: CGMProducts.DexcomG7_10Day.value,
  },
  DexcomG7_15Day: {
    value: 'DexcomG7_15Day',
    label: 'Dexcom G7 15-day',
    cgmModel: 'Dexcom G7',
    product: CGMProducts.DexcomG7_15Day.value,
  },
  FreestyleLibre2Plus: {
    value: 'FreestyleLibre2Plus',
    label: 'Freestyle Libre 2+',
    cgmModel: 'Freestyle Libre 2+',
  },
  FreestyleLibre3Plus: {
    value: 'FreestyleLibre3Plus',
    label: 'Freestyle Libre 3+',
    cgmModel: 'Freestyle Libre 3+',
  },
});

export const DiagnosisOptions = Object.freeze({
  'E10.9': {
    value: 'E10.9',
    label: 'E10.9',
  },
  'E11.65': {
    value: 'E11.65',
    label: 'E11.65',
  },
  'E10.65': {
    value: 'E10.65',
    label: 'E10.65',
  },
  'E11.8': {
    value: 'E11.8',
    label: 'E11.8',
  },
  'E11.9': {
    value: 'E11.9',
    label: 'E11.9',
  },
});

export const BooleanOptions = Object.freeze({
  YES: {
    value: true,
    label: 'Yes',
  },
  NO: {
    value: false,
    label: 'No',
  },
});
